(function () {
  var desktop = window.matchMedia('(min-width: 990px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function destroy() {
    if (!window.lenis) return;
    window.lenis.destroy();
    window.lenis = null;
  }

  function boot() {
    if (!window.Lenis) return;
    destroy();
    if (reduce.matches) return;

    var options = {
      smoothWheel: true,
      duration: 1.2,
      autoRaf: true,
      autoToggle: true,
      anchors: true,
      allowNestedScroll: true,
      stopInertiaOnNavigate: true,
      orientation: 'vertical',
      gestureOrientation: 'vertical',
    };

    if (desktop.matches) {
      var wrapper = document.querySelector('.page-wrapper');
      var content = document.querySelector('.wbs-scroll');
      if (wrapper && content) {
        options.wrapper = wrapper;
        options.content = content;
      }
    }

    window.lenis = new window.Lenis(options);
    document.dispatchEvent(new Event('wbs:lenis'));
  }

  desktop.addEventListener('change', boot);
  reduce.addEventListener('change', boot);
  window.addEventListener('pagehide', destroy);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
